module.exports = __webpack_public_path__ + "static/media/publicsonar_infrastructure_default.3cfb7c95.svg";